import { render, staticRenderFns } from "./NuevoMovimientoLogi.vue?vue&type=template&id=50d4be8a&scoped=true&"
import script from "./NuevoMovimientoLogi.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimientoLogi.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimientoLogi.vue?vue&type=style&index=0&id=50d4be8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4be8a",
  null
  
)

export default component.exports